/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
export class Status {
  status!: string;
  message!: string;
  errors: Errors = new Errors();
}

export class Errors {
  name!: string;
  status!: string;
  message!: string;
}
